import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AgencySocialLinks } from '@back/models/agency';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { socialIconFor } from './social-icons';

@Component({
  selector: 'app-social-media-links',
  templateUrl: './social-media-links.component.html',
  styleUrls: ['./social-media-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule],
})
export class SocialMediaLinksComponent {
  isRound = input<boolean>(false);
  socialLinks = input<AgencySocialLinks>([]);
  isSquare = input<boolean>(false);

  iconFor = socialIconFor;
}
